import {
  MerchantPaymentProduct,
  PaymentType,
  PaymentTypes,
} from '@ads-bread/shared/bread/codecs';
import { usd } from './money';

export const merchantPaymentProductProperties: MerchantPaymentProduct = {
  paymentProduct: {
    id: 'fb3e24a9-4030-4ccf-a209-93de0a4358a4',
    programID: 'b7beac2e-2714-4d1d-b110-72e405b41c34',
    name: 'Positive APR Payment Product',
    type: PaymentTypes.INSTALLMENTS,
    description: 'This is a description of a product.',
    numPayments: 12,
    paymentFrequency: 'P1M',
    minInterestRateBPS: 0,
    maxInterestRateBPS: 2999,
    paymentMethodTypes: ['ACH', 'DEBIT'],
    autopayRequired: false,
    legalAgreements: {},
    policies: {},
    workflowIDs: {},
    requiredDownPaymentBPS: 0,
    createdAt: '2021-02-27T00:36:59.6195794Z',
    deletedAt: null,
  },
  merchantValues: {
    maxCartSize: usd(2000000),
    minCartSize: usd(30000),
    preauthAmount: null,
  },
};

export const paymentProductID: Record<PaymentType, string> = {
  INSTALLMENTS: 'fb3e24a9-4030-4ccf-a209-93de0a4358a4',
  SPLITPAY: '7d80c76e-b0aa-41c3-b3d8-f54959ee67da',
};

/**
 * Creates installment payment product.
 *
 * @param paymentProduct - A payment product.
 * @param merchantValues - Merchant program values.
 *
 * @returns - Returns merchant payment product.
 *
 */
export function createInstallmentsPaymentProduct({
  paymentProduct,
  merchantValues,
}: {
  paymentProduct?: Partial<MerchantPaymentProduct['paymentProduct']>;
  merchantValues?: Partial<MerchantPaymentProduct['merchantValues']>;
} = {}): MerchantPaymentProduct {
  return {
    ...merchantPaymentProductProperties,
    paymentProduct: {
      ...merchantPaymentProductProperties.paymentProduct,
      id: paymentProductID.INSTALLMENTS,
      type: 'INSTALLMENTS',
      ...paymentProduct,
    },
    merchantValues: {
      ...merchantPaymentProductProperties.merchantValues,
      minCartSize: usd(30000),
      ...merchantValues,
    },
  };
}

/**
 * Creates split pay payment product.
 *
 * @param paymentProduct - A payment product.
 * @param merchantValues - Merchant program values.
 *
 * @returns - Returns merchant payment product.
 *
 */
export function createSplitPayPaymentProduct({
  paymentProduct,
  merchantValues,
}: {
  paymentProduct?: Partial<MerchantPaymentProduct['paymentProduct']>;
  merchantValues?: Partial<MerchantPaymentProduct['merchantValues']>;
} = {}): MerchantPaymentProduct {
  return {
    ...merchantPaymentProductProperties,
    paymentProduct: {
      ...merchantPaymentProductProperties.paymentProduct,
      id: paymentProductID.SPLITPAY,
      type: 'SPLITPAY',
      maxInterestRateBPS: 0,
      name: '0% APR Payment Product',
      numPayments: 4,
      paymentFrequency: 'P2W',
      paymentMethodTypes: ['DEBIT', 'CREDIT'],
      requiredDownPaymentBPS: 2500,
      autopayRequired: true,
      ...paymentProduct,
    },
    merchantValues: {
      minCartSize: usd(3000),
      maxCartSize: usd(150000),
      ...merchantValues,
      preauthAmount: 3000,
    },
  };
}
